import { useState } from "react";
import { toast } from "sonner";
import { Activity, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

const TONE = { operativo: "text-emerald-600", degradado: "text-amber-600", interrupcion: "text-destructive" };
const LABEL = { operativo: "Operativo", degradado: "Degradado", interrupcion: "Interrupción" };

export default function ModuleProbe({ moduleKey, item, onRefresh }) {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(item.http_code != null || item.latency_ms != null
    ? { estado: item.estado, http_code: item.http_code, latency_ms: item.latency_ms } : null);

  const check = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mod/${moduleKey}/items/${item.id}/probe`);
      setRes(data);
      data.error ? toast.error(data.error) : toast.success(`Servicio ${LABEL[data.estado] || data.estado}`);
      onRefresh?.();
    } catch (err) { toast.error(err?.response?.data?.detail || "Error al verificar"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-2" data-testid="module-probe">
      <div className="flex items-center justify-between gap-2">
        <div className="overline text-navy/40">Verificación en vivo</div>
        <button onClick={check} disabled={busy || !item.url} className="btn btn-primary" data-testid="probe-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Activity className="w-4 h-4" />} Verificar ahora
        </button>
      </div>
      {!item.url && <p className="text-sm text-navy/40">Agrega una URL (https://…) al servicio para poder verificarlo.</p>}
      {res && (
        <div className="flex flex-wrap items-center gap-4 text-sm" data-testid="probe-result">
          <span className={`font-medium ${TONE[res.estado] || "text-navy/60"}`}>● {LABEL[res.estado] || res.estado}</span>
          {res.http_code != null && <span className="text-navy/50">HTTP {res.http_code}</span>}
          {res.latency_ms != null && <span className="text-navy/50">{res.latency_ms} ms</span>}
        </div>
      )}
    </div>
  );
}
